import { createAction, createReducer, type PayloadAction } from '@reduxjs/toolkit'

export interface CaptchaReducer {
  isVerifying: boolean
  verifyFailed: boolean
}

const initialState: CaptchaReducer = {
  isVerifying: false,
  verifyFailed: false
}

export type VerifyCaptchaAction = PayloadAction<string>
export const VERIFY_CAPTCHA = createAction<string>('captcha/verify')
export const VERIFY_CAPTCHA_SUCCESS = createAction('captcha/verify_success')
export const VERIFY_CAPTCHA_FAIL = createAction('captcha/verify_fail')

export const captchaReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(VERIFY_CAPTCHA, (state) => {
      return { ...state, isVerifying: true, verifyFailed: false }
    })
    .addCase(VERIFY_CAPTCHA_SUCCESS, (state) => {
      return { ...state, isVerifying: false, verifyFailed: false }
    })
    .addCase(VERIFY_CAPTCHA_FAIL, (state) => {
      return { ...state, isVerifying: false, verifyFailed: true }
    })
})
